import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { CapacitorUpdater } from "@capgo/capacitor-updater";
import { Capacitor } from "@capacitor/core";

CapacitorUpdater.notifyAppReady();

// On web, serve the worker locally to avoid MIME type issues with the CDN.
// On native (iOS/Android), let ng2-pdf-viewer use its CDN fallback —
// the Capacitor WebView doesn't reliably serve .mjs files with the correct MIME type.
if (!Capacitor.isNativePlatform()) {
    (window as any).pdfWorkerSrc = "/pdf.worker.min.mjs";
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
